export const REQUEST_POOL: 'POOLS/REQUEST_POOL' = 'POOLS/REQUEST_POOL';
export const REQUEST_POOL_SUCCESS: 'POOLS/REQUEST_POOL_SUCCESS' = 'POOLS/REQUEST_POOL_SUCCESS';
export const REQUEST_POOL_FAILURE: 'POOLS/REQUEST_POOL_FAILURE' = 'POOLS/REQUEST_POOL_FAILURE';
